// src/PangeaCardModal.js
import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalContent,
  ModalOverlay,
  Flex,
  FormControl,
  PinInput,
  PinInputField,
  ModalHeader,
  VStack,
  Grid,
  Icon,
  GridItem,
  useColorModeValue,
  Text,
  useToast,
} from '@chakra-ui/react';

import InvoiceBg from "../../../assets/img/InvoiceBg.png";
import Card from "../../../components/card/Card.js";
import InputField from "../../../components/fields/InputField";

import { FaCheckCircle } from 'react-icons/fa';

const PangeaCardModal = ({ isOpen, onClose, submitCardData, submitPin, recepient, openLogin, amount, amountCrypto, item, isUserVerified, stage }) => {
  const toast = useToast();
  const [pin, setPin] = useState('');
  const [card, setCard] = useState('');
  const [ccv, setCcv] = useState('');

  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("secondaryGray.400", "whiteAlpha.100");
  

  const VerifiedIcon = () => {
    if (isUserVerified) {
      return (
        <Icon as={FaCheckCircle} boxSize={4} color="blue.400" />
      );
    }

    return (<></>);
  };

  const handleNumberClick = (number) => {
    if (pin.length < 6) {
      setPin(pin + number);
    }
  };

  const handleBackspaceClick = () => {
    setPin(pin.slice(0, -1));
  };

  const handleClearClick = () => {
    setPin('');
  };

  const handleSubmit = () => {
    if (pin.length === 6) {
      submitPin({
        pin: pin,
        card: card,
        ccv: ccv,
      });
      setPin('');
    }
  };

  const handleSubmitCard = () => {

    if (card.replace(/\s+/g, '').length===16 && ccv.replace(/\s+/g, '').length===4) {
      setCard(card.replace(/\s+/g, ''))
      setCcv(ccv.replace(/\s+/g, ''))
      submitCardData({
        card: card.replace(/\s+/g, ''),
        ccv: ccv.replace(/\s+/g, ''),
      });
      setPin('');
    } else {
      toast({
        title: 'Error.',
        description: "Card is not correct",
        status: 'error',
      })
    }
    setPin('');
  };

  const openLoginModal = () => {
    openLogin();
  }

  const cardLayout = () => {
    return (
      <>
        <ModalHeader>Enter your PayPangea card</ModalHeader>
            <VStack spacing={4} p={4}>
              
              <InputField
                mb='0px'
                me='30px'
                id='username'
                label='Card number'
                placeholder='Card number'
                value={card}
                onChange={(e) => setCard(e.target.value)}
              />
              <InputField
                mb='20px'
                me='30px'
                id='username'
                label='Card CVC'
                placeholder='CVC'
                value={ccv}
                onChange={(e) => setCcv(e.target.value)}
              />

              <Flex w="100%" direction='row' gap={2}>
                <Button onClick={openLoginModal} 
                    variant='outline' 
                    size="lg" 
                    w="100%">
                    Cancel
                </Button>
                <Button onClick={handleSubmitCard} 
                    variant='brand' 
                    size="lg" 
                    w="100%">
                    Next
                </Button>
              </Flex>
            </VStack>
      </>
    )
  }

  const pinLayout = () => {
    return (
      <>
        <ModalHeader>Enter your 6-digit PIN</ModalHeader>
            <VStack spacing={4} p={4}>
                <FormControl mb="20px">
                    <Flex justify="center">
                        <PinInput value={pin} onChange={(value) => setPin(value)} mask>
                            {Array.from({ length: 6 }, (_, i) => (
                                <PinInputField
                                  key={i}
                                  fontSize="24px"
                                  color={textColor}
                                  borderRadius="16px"
                                  borderColor={borderColor}
                                  h={{ base: '63px', md: '63px' }}
                                  w={{ base: '63px', md: '63px' }}
                                  me="10px"
                                />
                            ))}
                        </PinInput>
                    </Flex>
                </FormControl>
                <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                    {Array.from({ length: 9 }, (_, i) => (
                    <GridItem key={i} colSpan={1}>
                        <Button onClick={() => handleNumberClick(i + 1)} size="lg" w="100%">
                        {i + 1}
                        </Button>
                    </GridItem>
                    ))}
                    <GridItem colSpan={1}>
                    <Button onClick={handleClearClick} size="lg" w="100%">
                        Clear
                    </Button>
                    </GridItem>
                    <GridItem colSpan={1}>
                    <Button onClick={() => handleNumberClick(0)} size="lg" w="100%">
                        0
                    </Button>
                    </GridItem>
                    <GridItem colSpan={1}>
                    <Button onClick={handleBackspaceClick} size="lg" w="100%">
                        Back
                    </Button>
                    </GridItem>
                </Grid>

                <Flex w="100%" direction='row' gap={2}>
                  <Button onClick={openLoginModal} 
                      variant='outline' 
                      size="lg" 
                      w="100%">
                      Cancel
                  </Button>
                  <Button onClick={handleSubmit} 
                      variant='brand' 
                      size="lg" 
                      w="100%">
                      Pay
                  </Button>
                </Flex>
            </VStack>
      </>
    )
  }

  return (
    <Modal 
        isCentered 
        autoFocus={false}
        motionPreset='slideInBottom'
        isOpen={isOpen} 
        onClose={onClose} 
        size="xs">
        <ModalOverlay
            bg='none'
            backdropFilter='auto'
            backdropBlur='8px'/>
        <ModalContent>

            <Card
              backgroundImage={InvoiceBg}
              backgroundRepeat='no-repeat'
              bgSize='cover'
              bgPosition='10%'
              borderRadius="5px 5px 0 0" 
              p="20px"
              pb="40px">
              <Flex mb={{ base: "0px", md: "0px" }} direction="column">
                <Grid
                  templateColumns="1fr 2fr" // 1/3 and 2/3 width
                  gap={2} // Adjust the gap between grid items
                >
                  <GridItem colSpan={1}>
                    {item && item.trim()!=='' && (
                      <Text fontSize="md" mt="0px" fontWeight='regular'>
                        Item:
                      </Text>
                    )}
                    <Text fontSize="md" mt="0px" fontWeight='regular'>
                      Recepient:
                    </Text>
                    {isUserVerified && (
                      <Text fontSize="md" mt="0px" fontWeight='regular'>
                        Verified:
                      </Text>
                    )}
                    {amount && amount.trim()!=='' && (
                      <Text fontSize="md" mt="0px" fontWeight='regular'>
                        Amount:
                      </Text>
                    )}
                    <Text fontSize="md" mt="0px" fontWeight='regular'>
                      Crypto:
                    </Text>
                  </GridItem>
                  <GridItem colSpan={1}>
                    {item && item.trim()!=='' && (
                      <Text fontSize="md" mt="0px" fontWeight='regular'>
                        {item.length > 30 ? `${item.substr(0,24)}...}` : item}
                      </Text>
                    )}
                    <Text fontSize="md" mt="0px" fontWeight='regular'>
                      {recepient.length > 30 ? `${recepient.substr(0,8)}...${recepient.slice(-6)}` : recepient}
                    </Text>

                    {VerifiedIcon()}
                    {amount && amount.trim()!=='' && (
                      <Text fontSize="md" mt="0px" fontWeight='regular'>
                        {amount}
                      </Text>
                    )}
                    <Text fontSize="md" mt="0px" fontWeight='regular'>
                      {amountCrypto}
                    </Text>
                  </GridItem>
                </Grid>
              </Flex>
            </Card>
            {stage === 0 && (
              cardLayout()
            )}
            {stage === 1 && (
              pinLayout()
            )}
            
        </ModalContent>
    </Modal>
  );
};

export default PangeaCardModal;
